import { AudienceCatalogScreen } from "types";
import { createScreen } from "utils/createScreen";

const UpdateAudienceDefinition = createScreen({
  name: AudienceCatalogScreen,
  path: "/audience-catalog/edit/:id",
  routePath: ["/edit/:id"],
  accessPath: "audienceCatalog",
});

export { UpdateAudienceDefinition };
